import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Index from "./pages/Home";
import ContactUs from "./pages/ContactUs";
import PP from "./pages/PrivacyPolicy";
import TermsofUse from "./pages/TermsofUse";
import ComplainPolicy from "./pages/ComplainPolicy";
import SchemaComponent from "./components/universal/schema-component";
import { HelmetProvider } from "react-helmet-async";
function App() {
  return (
    <Router>
      <HelmetProvider>
        <SchemaComponent />
      </HelmetProvider>
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/privacy-policy" element={<PP />} />
        <Route path="/terms-of-use" element={<TermsofUse />} />
        <Route path="/complain-policy" element={<ComplainPolicy />} />
      </Routes>
    </Router>
  );
}

export default App;
